module.exports = __webpack_public_path__ + "img/百合花.dd892e7e.jpg";